import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewDocumentsComponent } from './preview-documents.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule } from "@angular/material/legacy-checkbox";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";


@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatLegacyCheckboxModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [PreviewDocumentsComponent]
})
export class PreviewDocumentsModule { }
